import axios from 'axios';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://api.viafiltros.com.br').replace(/\/$/, '');
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/** URL do stream (foto/vídeo) com o JWT — o <video> não envia Authorization. */
export function urlMidiaManutencao(manutencaoId, fotoId) {
  const token = localStorage.getItem('token');
  if (!manutencaoId || !fotoId || !token) return null;
  return `${API_URL}/manutencoes/${encodeURIComponent(manutencaoId)}/midias/${encodeURIComponent(fotoId)}?mt=${encodeURIComponent(token)}`;
}

export default api;
